// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline--1W5Ex","logoContainer":"logoContainer--1z6lO"};